import { combineReducers } from "@reduxjs/toolkit"

// reducers
import cvSlice from "./slices/cvSlice"
import jobSlice from "./slices/jobSlice"
import authSlice from "./slices/authSlice"
import configSlice from "./slices/configSlice"
import creditSlice from "./slices/creditSlice"
import signupSlice from "./slices/signupSlice"
import matchSlice from "./slices/matchSlice"
import integrationSlice from "./slices/integrationSlice"
import toastSlice from "./slices/toastSlice"

const appReducer = combineReducers({
  config: configSlice,
  cv: cvSlice,
  jobs: jobSlice,
  match: matchSlice,
  auth: authSlice,
  credit: creditSlice,
  signup: signupSlice,
  integrations: integrationSlice,
  toast: toastSlice,
})

const rootReducer = (state, action) => {
  // Clean up state on logout
  if (action.type === "auth/logoutAction") {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer